import GasAnalyzer from "../assets/images/products/opsis/gas-analyzer.webp";
import EmitterReceiver from "../assets/images/products/opsis/emitter-receiver.webp";
import PowerSupply from "../assets/images/products/opsis/power-supply.webp";
import MeasurementCell from "../assets/images/products/opsis/measurement-cell.webp";
import CalibrationBench from "../assets/images/products/opsis/calibration-bench.webp";
import CalibrationCell from "../assets/images/products/opsis/calibration-cell.webp";
import HovaCalN from "../assets/images/products/opsis/hovacal-n.webp";
import FMD09 from "../assets/images/products/dr-fodisch/fmd09.webp";
import FMD09Inside from "../assets/images/products/dr-fodisch/fmd09-inside.webp";
import OPASTOP from "../assets/images/products/five-pillars/OPASTOP-GP4000HO.webp";

export const opsisProductImage = {
  GasAnalyzer,
  EmitterReceiver,
  PowerSupply,
  MeasurementCell,
  CalibrationBench,
  CalibrationCell,
  HovaCalN,
};

export const drFodischProductImage = {
  FMD09: FMD09,
  FMD09Inside: FMD09Inside,
};

export const fivePillarsProductImage = {
  OPASTOP: OPASTOP,
};
